import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export default lazyLoadComponentFactory(() => import(/* webpackChunkName: "register-now" */ "./RegisterNow"));
